var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFractional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9192 17.1024V0C25.4933 0.480405 29.356 2.30594 32.5073 5.47661C35.6573 8.64728 37.4882 12.5225 38 17.1024H20.9192ZM17.1288 38C12.2668 37.5196 8.19687 35.4699 4.91889 31.8508C1.63963 28.2318 0 23.9562 0 19.024C0 14.0598 1.63963 9.76823 4.91889 6.14918C8.19687 2.53013 12.2668 0.480405 17.1288 0V38ZM20.9192 38V20.8976H38C37.5522 25.4775 35.7366 29.361 32.5533 32.5484C29.3713 35.7344 25.4933 37.5516 20.9192 38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFractional);
export default __webpack_public_path__ + "static/media/fractional.63955971d28581fdeba86fbfcb6d5959.svg";
export { ForwardRef as ReactComponent };